<template>
  <svg :width="size ? size.width : 16" :height="size ? size.height : 16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.1857 1.11291C8.06649 1.06523 7.93351 1.06523 7.8143 1.11291L1.84629 3.50012L8 5.9616L14.1537 3.50012L8.1857 1.11291ZM15 4.23863L8.5 6.83863V14.7616L15 12.1616V4.23863ZM7.5 14.7616V6.83863L1 4.23863V12.1616L7.5 14.7616ZM7.44291 0.184433C7.80053 0.0413868 8.19947 0.0413868 8.55709 0.184433L15.6857 3.03588C15.8755 3.11181 16 3.29566 16 3.50012V12.1616C16 12.5705 15.751 12.9382 15.3714 13.0901L8.1857 15.9644C8.06649 16.012 7.93351 16.012 7.8143 15.9644L0.628609 13.0901C0.248951 12.9382 0 12.5705 0 12.1616V3.50012C0 3.29566 0.124475 3.11181 0.314305 3.03588L7.44291 0.184433Z" fill="#044389"/>
  </svg>
  </template>
<script>
export default {
  props:['size']
}
</script>